import { RentalDetailsPackOptionSelectionItem } from
    "../../../../Models/Rental/Details/RentalDetailsPackOptionSelectionItem";
import { PriceHelper } from "../../../../Lib/Helper/PriceHelper";
import { AxLoad } from "../../../../Lib/AxSystem/AxLoad";
import { RentalProductDetails } from "../RentalProductDetails";
import { RentDetailsPackItemSelectionSection } from "./RentDetailsPackItemSelectionSection";
import { LocalizationModule } from "../../../Global/LocalizationModule";

export class RentDetailsProdOptItemSelectSection {

    private htmlElement: HTMLDivElement;

    private itemSelectionData: RentalDetailsPackOptionSelectionItem[];
    private parentComponent: RentDetailsPackItemSelectionSection;

    constructor(availableOptionalItems: RentalDetailsPackOptionSelectionItem[], drawSeparator: boolean, wrapper: HTMLElement,
        parentComponent: RentDetailsPackItemSelectionSection) {

        this.parentComponent = parentComponent;
        this.itemSelectionData = [];

        const row = document.createElement("div");
        row.classList.add("row");

        this.htmlElement = row;

        wrapper.appendChild(row);

        if (drawSeparator) {
            const separator = document.createElement("div");
            separator.classList.add("ax-divider");
            separator.classList.add("ax-mb-2");
            row.appendChild(separator);
        }

        for (let i = 0; i < availableOptionalItems.length; i++) {
            const newItemSelectionData = new RentalDetailsPackOptionSelectionItem(availableOptionalItems[i].productId,
                availableOptionalItems[i].packagePosition,
                availableOptionalItems[i].productName,
                availableOptionalItems[i].productPrice,
                availableOptionalItems[i].isSelected);

            this.itemSelectionData.push(newItemSelectionData);

            const checkBoxCol = this.getCheckBoxCol(newItemSelectionData);
            row.appendChild(checkBoxCol);
        }
    }

    destroyElement() {
        this.htmlElement.remove();
    }

    getSelectedItemsIds(): RentalDetailsPackOptionSelectionItem[] {
        const selectedItemIds = this.itemSelectionData
            .filter(x => x.isSelected);

        return selectedItemIds;
    }

    getSelectedItemsPriceSum(): number {

        let optItemsTotalPrice = 0;

        for (let y = 0; y < this.itemSelectionData.length; y++) {
            const selectionData = this.itemSelectionData[y];

            if (selectionData.isSelected) {
                optItemsTotalPrice += selectionData.productPrice;
            }
        }

        return optItemsTotalPrice;
    }

    private getCheckBoxCol(optionalItem: RentalDetailsPackOptionSelectionItem): HTMLDivElement {
        const col = document.createElement("div");
        col.classList.add("col-12");
        col.classList.add("col-md-6");

        const checkboxWrapper = document.createElement("div");
        checkboxWrapper.classList.add("ax-checkbox-wrapper");

        let localizationModule = AxLoad.GetModule<LocalizationModule>('LocalizationModule');
        let priceHelper = new PriceHelper(localizationModule.getCultureInfo(), true);

        const priceString = priceHelper.GetPriceStringWithCurrencySymbol(optionalItem.productPrice / localizationModule.getPriceToDecimalDivisor());

        const optionalItemLabelString = `${optionalItem.productName} ( + ${priceString})`;
        const label = document.createElement("label");
        label.classList.add("ax-checkbox");
        label.innerHTML = optionalItemLabelString;

        const optionalItemIdentifier = `prod__check_optional_${optionalItem.productId}`;
        const checkBox = document.createElement("input");
        checkBox.name = optionalItemIdentifier;

        if (optionalItem.isSelected) {
            checkBox.checked = true;
        }
        checkBox.type = "checkbox";

        const span = document.createElement("span");
        span.classList.add("ax-checkbox__checkmark");

        label.appendChild(checkBox);
        label.appendChild(span);
        checkboxWrapper.appendChild(label);
        col.appendChild(checkboxWrapper);

        this.initCheckBox(checkBox, optionalItem);

        return col;
    }

    private initCheckBox(checkBox: HTMLInputElement, optionalItem: RentalDetailsPackOptionSelectionItem) {
        checkBox.addEventListener('change', (event) => {
            optionalItem.isSelected = checkBox.checked;
            this.parentComponent.updatePriceLabels();
            AxLoad.GetModule<RentalProductDetails>('RentalProductDetails').refreshProceedBtn();
        });
    }
}